// store/admin/exam-management/store/_actions.js
import * as types from './_actionTypes';

// Get all exams
export const getAllExams = (params) => ({
  type: types.GET_ALL_EXAMS_REQUEST,
  payload: params
});

export const getAllExamsSuccess = (data) => ({
  type: types.GET_ALL_EXAMS_SUCCESS,
  payload: data
});

export const getAllExamsFailure = (error) => ({
  type: types.GET_ALL_EXAMS_FAILURE,
  payload: error
});

// Get exam by ID
export const getExamById = (examId) => ({
  type: types.GET_EXAM_BY_ID_REQUEST,
  payload: { examId }
});

export const getExamByIdSuccess = (data) => ({
  type: types.GET_EXAM_BY_ID_SUCCESS,
  payload: data
});

export const getExamByIdFailure = (error) => ({
  type: types.GET_EXAM_BY_ID_FAILURE,
  payload: error
});

// Create exam
export const createExam = (examData) => ({
  type: types.CREATE_EXAM_REQUEST,
  payload: examData
});

export const createExamSuccess = (data) => ({
  type: types.CREATE_EXAM_SUCCESS,
  payload: data
});

export const createExamFailure = (error) => ({
  type: types.CREATE_EXAM_FAILURE,
  payload: error
});

// Update exam
export const updateExam = (examId, updateData) => ({
  type: types.UPDATE_EXAM_REQUEST,
  payload: { examId, updateData }
});

export const updateExamSuccess = (data) => ({
  type: types.UPDATE_EXAM_SUCCESS,
  payload: data
});

export const updateExamFailure = (error) => ({
  type: types.UPDATE_EXAM_FAILURE,
  payload: error
});

// Delete exam
export const deleteExam = (examId) => ({
  type: types.DELETE_EXAM_REQUEST,
  payload: { examId }
});

export const deleteExamSuccess = (examId) => ({
  type: types.DELETE_EXAM_SUCCESS,
  payload: examId
});

export const deleteExamFailure = (error) => ({
  type: types.DELETE_EXAM_FAILURE,
  payload: error
});

// Toggle exam status
export const toggleExamStatus = (examId, isActive) => ({
  type: types.TOGGLE_EXAM_STATUS_REQUEST,
  payload: { examId, isActive }
});

export const toggleExamStatusSuccess = (data) => ({
  type: types.TOGGLE_EXAM_STATUS_SUCCESS,
  payload: data
});

export const toggleExamStatusFailure = (error) => ({
  type: types.TOGGLE_EXAM_STATUS_FAILURE,
  payload: error
});

// Declare exam results
export const declareExamResults = (examId, resultsDeclared) => ({
  type: types.DECLARE_EXAM_RESULTS_REQUEST,
  payload: { examId, resultsDeclared }
});

export const declareExamResultsSuccess = (data) => ({
  type: types.DECLARE_EXAM_RESULTS_SUCCESS,
  payload: data
});

export const declareExamResultsFailure = (error) => ({
  type: types.DECLARE_EXAM_RESULTS_FAILURE,
  payload: error
});

// Get exam attempts
export const getExamAttempts = (examId) => ({
  type: types.GET_EXAM_ATTEMPTS_REQUEST,
  payload: { examId }
});

export const getExamAttemptsSuccess = (data) => ({
  type: types.GET_EXAM_ATTEMPTS_SUCCESS,
  payload: data
});

export const getExamAttemptsFailure = (error) => ({
  type: types.GET_EXAM_ATTEMPTS_FAILURE,
  payload: error
});

// Get exam analytics (live)
export const getExamAnalytics = (examId) => ({
  type: types.GET_EXAM_ANALYTICS_REQUEST,
  payload: { examId }
});

export const getExamAnalyticsSuccess = (data) => ({
  type: types.GET_EXAM_ANALYTICS_SUCCESS,
  payload: data
});

export const getExamAnalyticsFailure = (error) => ({
  type: types.GET_EXAM_ANALYTICS_FAILURE,
  payload: error
});

export const clearExamAnalytics = () => ({
  type: types.CLEAR_EXAM_ANALYTICS
});

// Add exam questions
export const addExamQuestions = (examId, questions) => ({
  type: types.ADD_EXAM_QUESTIONS_REQUEST,
  payload: { examId, questions }
});

export const addExamQuestionsSuccess = (data) => ({
  type: types.ADD_EXAM_QUESTIONS_SUCCESS,
  payload: data
});

export const addExamQuestionsFailure = (error) => ({
  type: types.ADD_EXAM_QUESTIONS_FAILURE,
  payload: error
});

// Update exam questions
export const updateExamQuestions = (examId, questions) => ({
  type: types.UPDATE_EXAM_QUESTIONS_REQUEST,
  payload: { examId, questions }
});

export const updateExamQuestionsSuccess = (data) => ({
  type: types.UPDATE_EXAM_QUESTIONS_SUCCESS,
  payload: data
});

export const updateExamQuestionsFailure = (error) => ({
  type: types.UPDATE_EXAM_QUESTIONS_FAILURE,
  payload: error
});

// Local state management
export const setSelectedExam = (exam) => ({
  type: types.SET_SELECTED_EXAM,
  payload: exam
});

export const clearExamError = () => ({
  type: types.CLEAR_EXAM_ERROR
});

export const resetExamForm = () => ({
  type: types.RESET_EXAM_FORM
});